var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-range-select"
  }, [_c('div', {
    staticClass: "input-range-select__labels"
  }, [_c('div', {
    staticClass: "input-range-select__label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.unitsBefore)
    }
  }), _vm._v(_vm._s(_vm.formatValue(this.valueRange[0]))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.unitsAfter)
    }
  })]), _c('div', {
    staticClass: "input-range-select__label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.unitsBefore)
    }
  }), _vm._v(_vm._s(_vm.formatValue(this.valueRange[1]))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.unitsAfter)
    }
  })])]), _c('div', {
    staticClass: "slider"
  }, [_c('vue-slider', _vm._b({
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.valueRange,
      callback: function callback($$v) {
        _vm.valueRange = $$v;
      },
      expression: "valueRange"
    }
  }, 'vue-slider', _vm.options, false))], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }